<template>
  <div class="three-intro">
    <p>
      <span class="caps">Q</span>uelques heures et quelques cafés seulement vous auront été nécessaires pour
      découvrir la première lettre du nom de l'assassin. C'est donc confiant et motivé que vous
      retournez chez Carmen qui vous félicite pour votre avancée. Elle vous attendait&nbsp;:&nbsp;une
      planche de Ouija est disposée sur la table. Ce soir, vous allez être mis à contribution pour échanger avec le monde de l'au-delà.
    </p>
  </div>
</template>
<script>
export default {
  name: "ThreeIntro"
};
</script>

<style scoped>
p {
  font-family: "Libre Caslon Text", serif;
  font-size: 15px;
}
.three-intro {
  padding: 10% 18%;
  font-size: 20px;
  overflow: scroll;
  text-align: justify;
  height: 80%;
}
.caps {
  color: rgba(0, 0, 0, 0.7);
  float: left;
  font-size: 110px;
  line-height: 0.9em;
  padding-right: 12px;
  position: relative;
  top: 8px;
}
</style>